import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.gNo4yqZLyVsqpic5Zs00KP7CsAy23D-bnVPznxX4eG2UDjRQvIByzv-6rx7si15E9Koh_mHhuYVtHfKmGNUG1JUctumv5hB6GLGlAzUeR8wcduvm6kROuNmRejt2XsWBuYwL7xlBLJMwG0R81RojGvJE6kYFb-Lfsl3Z6qARFwZ8gBB18r7HUnTxM3Wnxph0TQ2Ljtvfgzd_TAD_5NA0m3t7M7thf1Z1Txs3dWYvbwfdI9rU8GYu1WgR1720fkCV8OMLvwTnuCJV2qMK1fpMFWXBhi0tYoD42OXXqtOtzRbD4BbTfNAI32k4NAB08aUuNowU7wtiBXx23CfkrG_H7p0G0nACv5R7mw",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-09-21T15:58:58.595242Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.gNo4yqZLyVsqpic5Zs00KP7CsAy23D-bnVPznxX4eG2UDjRQvIByzv-6rx7si15E9Koh_mHhuYVtHfKmGNUG1JUctumv5hB6GLGlAzUeR8wcduvm6kROuNmRejt2XsWBuYwL7xlBLJMwG0R81RojGvJE6kYFb-Lfsl3Z6qARFwZ8gBB18r7HUnTxM3Wnxph0TQ2Ljtvfgzd_TAD_5NA0m3t7M7thf1Z1Txs3dWYvbwfdI9rU8GYu1WgR1720fkCV8OMLvwTnuCJV2qMK1fpMFWXBhi0tYoD42OXXqtOtzRbD4BbTfNAI32k4NAB08aUuNowU7wtiBXx23CfkrG_H7p0G0nACv5R7mw'

// {
//   "access_token": "v2.local.LOfWZc4LI3FGbnxCpp71U1DSut8ofC2foiyshj34Q5DTLKgJ5D_gnJZM4YlOk7a8-UncSrT38bvL-IYnx8Vla-Q_ZmHdMzcxyEnTRPFMzne16Ufrnfg23pvWISv9jgSBIBx4sLBPa_hmloz3XQRKZVQI4mWG9aPMjzj_bPduAUIFs4GzUCgEaoteLCvD03vUyBsY5mKe9Tvtvr4xajMecwO9q5IIvMng5acTh5aKSvkNKbODOX8kxwI7IVqOG6WHS4f9qpJnD_SyN-AHKrFoAwELCKJC8zbzv8yoE1aLZLttlRsEGgSHdMsFpGuTOhRCBgWf1m1bIj4QXh8k0VtqHDPlDPOZ",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-09-21T15:58:58.928705Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.LOfWZc4LI3FGbnxCpp71U1DSut8ofC2foiyshj34Q5DTLKgJ5D_gnJZM4YlOk7a8-UncSrT38bvL-IYnx8Vla-Q_ZmHdMzcxyEnTRPFMzne16Ufrnfg23pvWISv9jgSBIBx4sLBPa_hmloz3XQRKZVQI4mWG9aPMjzj_bPduAUIFs4GzUCgEaoteLCvD03vUyBsY5mKe9Tvtvr4xajMecwO9q5IIvMng5acTh5aKSvkNKbODOX8kxwI7IVqOG6WHS4f9qpJnD_SyN-AHKrFoAwELCKJC8zbzv8yoE1aLZLttlRsEGgSHdMsFpGuTOhRCBgWf1m1bIj4QXh8k0VtqHDPlDPOZ'

// {
//   "access_token": "v2.local.K44djdWRLdNQ8tNB026QuBeS12nRdX4HVbywPpkfUfhnMM2hASf2spDV8mrmVaLhdK0gX3_Mwaz6IJ8fjrx193zIWhvTIMVbhrSL7labZtovNTrfQct3Nw8uekaLTQ3DVg72tIIfTCsK0HC-EY5ApNoX_klnV5wqQ9lkD1FQYVTPSpSnb9mputbpym_5rfbHbSAOL_J3KGKDxTbDuiZxo9dKUHAl2buXdAlXLnG-Uu0jMdh5dADlRVqTe0ro1eU_3kmOvMpa-fnIo_kySaOYLAGef1QTe-qwI7AVlk8S6NvqdldvUCU3Scp38SQMl-n8pswV2J3lE1Rwaia11vHNRa96ZC0",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-09-21T15:58:59.282609Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.K44djdWRLdNQ8tNB026QuBeS12nRdX4HVbywPpkfUfhnMM2hASf2spDV8mrmVaLhdK0gX3_Mwaz6IJ8fjrx193zIWhvTIMVbhrSL7labZtovNTrfQct3Nw8uekaLTQ3DVg72tIIfTCsK0HC-EY5ApNoX_klnV5wqQ9lkD1FQYVTPSpSnb9mputbpym_5rfbHbSAOL_J3KGKDxTbDuiZxo9dKUHAl2buXdAlXLnG-Uu0jMdh5dADlRVqTe0ro1eU_3kmOvMpa-fnIo_kySaOYLAGef1QTe-qwI7AVlk8S6NvqdldvUCU3Scp38SQMl-n8pswV2J3lE1Rwaia11vHNRa96ZC0'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
